import numeral from 'numeral'
import "numeral/locales/es";

numeral.locale('es')

export function clp(v) {
  return numeral(v).format('0,0')
}

export default numeral